import axios from 'axios';
import helpers from '../helpers/helpers';
import search from './search';

const filters = {
	page: document.querySelector('.js-filtering'),
	peoplePage: document.querySelector('.js-main-people'),
	newsPage: document.querySelector('.js-main-news'),
	portfolioPage: document.querySelector('.js-main-portfolio'),
	filterMenuBtn: document.querySelector('.js-filter-mobile'),
	filterMenuBtnClose: document.querySelectorAll('.js-filter-menu-close'),
	filterBtnList: document.querySelectorAll('.js-filters-btn-list'),
	allFilterList: document.querySelectorAll('.js-filter-list'),
	filterList: document.querySelector('.js-filter-list'),
	filterMenu: document.querySelector('.js-filter-holder'),
	filterActiveContainer: document.querySelector(
		'.js-filter-active-container'
	),
	filterDropdown: document.querySelectorAll('.js-filters-dropdown-btn'),
	filterActive: document.querySelectorAll('.js-filters-active'),
	clearFiltersBtn: document.querySelectorAll('.js-clear-filters'),
	filterCategory: document.querySelectorAll('.js-filter-category'),
	mobileMenuOpen: 'filters__filter-holder--open',
	filterListDropdown: 'filters__dropdown-list--open',
	filterActiveClass: 'filters__filter-btn--active',
	filterOpenDropdown: 'filters__filter-btn--open',
	filterMobileBtnClose: 'filters__mobile-btn--close',
	pageMainZIndexClass: 'main--filter',

	currentCategory: [],
	currentType: [],
	currentTheme: [],
	currentStrategy: [],
	currentStatus: [],
	currentLocations: [],
	isPageInit: false,
	isInitialPrioritisationCancled: false,

	init: function() {
		if (!this.page || !this.filterMenu) return;
		this.openFilterMenu();
		this.closeFilterMenu();
		this.openFilterBtnList();
		this.activeFilterDisplay();
		this.clearAllFilters();
		this.onPaginationBtn();
		this.handleFilterBtnStates();
		setTimeout(() => {
			this.checkFilterInit();
		}, 250);
	},

	openFilterMenu: function() {
		this.filterMenuBtn?.addEventListener('click', () => {
			if (
				this.filterMenuBtn.classList.contains(this.filterMobileBtnClose)
			) {
				return;
			}
			helpers.disableScroll();
			this.filterMenu.classList.add(this.mobileMenuOpen);
			this.filterList.classList.remove(this.filterListDropdown);

			this.handleMainZindexClass();
		});
	},

	closeFilterMenu: function() {
		this.filterMenuBtnClose?.forEach((btn) => {
			btn.addEventListener('click', () => {
				helpers.enableScroll();
				this.filterMenu.classList.remove(this.mobileMenuOpen);
				this.handleMainZindexClass(false);
			});
		});
	},

	handleMainZindexClass: function(shouldAddClass = true) {
		if (!window.matchMedia('(max-width: 1200px)').matches) return;

		if (shouldAddClass) {
			this.page.classList.add(this.pageMainZIndexClass);
			return;
		}

		this.page.classList.remove(this.pageMainZIndexClass);
	},

	checkFilterInit: function() {
		if (this.filterActive.length > 0) {
			this.filterActive.forEach((activeBtn) => {
				const filterText = activeBtn.textContent;

				activeBtn.addEventListener('click', () => {
					this.currentCategory = this.currentCategory.filter(
						(category) => category !== filterText.trim()
					);
					this.currentType = this.currentType.filter(
						(type) => type !== filterText.trim()
					);
					this.currentLocations = this.currentLocations.filter(
						(location) => location !== filterText.trim()
					);
					this.currentStatus = this.currentStatus.filter(
						(status) => status !== filterText.trim()
					);
					this.currentStrategy = this.currentStrategy.filter(
						(strategy) => strategy !== filterText.trim()
					);
					this.currentTheme = this.currentTheme.filter(
						(theme) => theme !== filterText.trim()
					);

					this.removeActiveFilter(filterText);

					if (this.peoplePage) {
						this.callAxiosPeople(
							this.currentType,
							this.currentCategory,
							1,
							true
						);
					} else if (this.newsPage) {
						this.callAxiosNews(
							this.currentType,
							this.currentCategory
						);
					} else if (this.portfolioPage) {
						this.callAxiosPortfolio(
							this.currentTheme,
							this.currentStrategy,
							this.currentStatus,
							this.currentLocations,
							1,
							true
						);
					}
				});

				const filterBtn = this.page.querySelector('.js-location');
				if (filterBtn) {
					this.currentLocations.push(filterText.trim());
				}
			});
			const initFilterValue = [...this.filterActive].map((filter) => filter.textContent.trim());

			document
				.querySelector('.js-location')
				.querySelectorAll('.js-filters-dropdown-btn')
				.forEach((btn) => {
					const dataType = btn.getAttribute('data-type');
					if (dataType === initFilterValue) {
						const parent = btn.closest('.js-filter-list');
						const prevSibling = parent.previousElementSibling;
						prevSibling.classList.add('filters__filter-btn--arrow');
						prevSibling.classList.add('filters__filter-btn--open');
					}
				});

			initFilterValue.forEach((filter) => this.currentType.push(filter));

			if (this.peoplePage) {
				this.callAxiosPeople(this.currentType, this.currentCategory, 1, true);
			} else if (this.newsPage) {
				this.callAxiosNews(this.currentType, this.currentCategory);
			} else if (this.portfolioPage) {
				this.callAxiosPortfolio(
					this.currentTheme,
					this.currentStrategy,
					this.currentStatus,
					this.currentLocations,
					1,
					true
				);
			}
		} else {
			filters.isPageInit = true;
		}
	},

	openFilterBtnList: function() {
		document.addEventListener('click', (e) => {
			this.filterBtnList.forEach((btn, index) => {
				if (btn !== e.target && btn.classList.contains('filters__filter-btn--open') || btn.classList.contains('filters__filter-btn--arrow')) {
					const btnDrodpown = btn.nextElementSibling;
					btn.classList.remove('filters__filter-btn--open', 'filters__filter-btn--arrow');
					btnDrodpown.classList.remove('filters__dropdown-list--open');
				}
			});
		});
		this.filterBtnList?.forEach((filterBtn) => {
			filterBtn.addEventListener('click', (event) => {
				event.stopPropagation();

				if (
					filterBtn.classList.contains('filters__filter-btn--arrow')
				) {
					filterBtn.classList.remove('filters__filter-btn--arrow');
				}

				const currentDropdown = filterBtn.nextElementSibling;
				if (event.target === filterBtn) {
					this.filterBtnList.forEach((btn) => {
						const otherDropdown = btn.nextElementSibling;
						if (btn !== filterBtn) {
							btn.classList.remove(this.filterOpenDropdown);
							otherDropdown.classList.remove(
								this.filterListDropdown
							);
						}
					});
					if (filterBtn.classList.contains(this.filterOpenDropdown)) {
						filterBtn.classList.remove(this.filterOpenDropdown);
					} else {
						filterBtn.classList.add(this.filterOpenDropdown);
					}
					if (currentDropdown.classList.contains(this.filterListDropdown)) {
						currentDropdown.classList.remove(this.filterListDropdown);
					} else {
						currentDropdown.classList.add(this.filterListDropdown);
					}
				}

				this.clearFiltersBtn.forEach((btn) => {
					if (btn.classList.contains('filters__filter-btn--all')) {
						btn.classList.remove('filters__filter-btn--color');
					}
				});

				this.clearFiltersBtn.forEach((clearBtn) => {
					if (
						clearBtn.classList.contains(
							'filters__filter-btn--all'
						) &&
						this.currentType.length === 0 &&
						this.currentTheme.length === 0 &&
						this.currentStrategy.length === 0 &&
						this.currentStatus.length === 0 &&
						this.currentLocations.length === 0 &&
						this.currentCategory.length === 0
					) {
						clearBtn.classList.add('filters__filter-btn--color');
					} else {
						clearBtn.classList.remove('filters__filter-btn--color');
					}
				});
			});
		});

		this.filterDropdown?.forEach((dropdownBtn) => {
			dropdownBtn.addEventListener('click', () => {
				const dropdownList = dropdownBtn.closest('.js-filter-list');
				if (dropdownList) {
					dropdownList.classList.remove(this.filterListDropdown);
				}
			});
		});
	},

	activeFilterDisplay: function() {
		this.filterDropdown?.forEach((btn) => {
			btn.addEventListener('click', (event) => {
				if (!this.isInitialPrioritisationCancled) {
					this.clearFilterOnSubmit();
					this.isInitialPrioritisationCancled = true;
				}

				if (
					this.currentType.includes(event.target.textContent.trim())
				) {
					document
						.querySelectorAll('.js-filters-btn-list')
						.forEach((btn) => {
							if (event.target === btn) {
								btn.classList.add('filters__filter-btn--arrow');
							}
						});
					return;
				}

				this.filterActiveContainer.classList.add(
					'filters__active-container--active'
				);
				search.clearSearchOnFilters();
				this.addActiveFilter(btn.textContent, btn);
				this.filterList.classList.remove(this.filterListDropdown);

				const filterWrap = btn.closest('.js-filter-btn-wrap');

				if (filterWrap) {
					const filterBtnClosest = filterWrap.querySelector(
						'.js-filters-btn-list'
					);

					if (filterBtnClosest && event.target === btn) {
						filterBtnClosest.classList.add(
							'filters__filter-btn--arrow'
						);
					}
				}

				const type = btn.dataset.type;
				this.currentType.push(type);

				const themeFilter = btn.closest('.js-theme');
				const strategyFilter = btn.closest('.js-strategy');
				const statusFilter = btn.closest('.js-status');
				const locationsFilter = btn.closest('.js-location');

				if (themeFilter) {
					this.currentTheme = [
						...new Set([...this.currentTheme, type]),
					];
				}
				if (strategyFilter) {
					this.currentStrategy = [
						...new Set([...this.currentStrategy, type]),
					];
				}
				if (statusFilter) {
					this.currentStatus = [
						...new Set([...this.currentStatus, type]),
					];
				}
				if (locationsFilter) {
					this.currentLocations = [
						...new Set([...this.currentLocations, type]),
					];
				}

				if (this.peoplePage) {
					this.callAxiosPeople(
						this.currentType,
						this.currentCategory,
						1
					);
				} else if (this.newsPage) {
					this.callAxiosNews(this.currentType, this.currentCategory);
				} else if (this.portfolioPage) {
					this.callAxiosPortfolio(
						this.currentTheme,
						this.currentStrategy,
						this.currentStatus,
						this.currentLocations
					);
				}

				btn.classList.add(this.filterActiveClass);

				this.clearFiltersBtn.forEach((btn) => {
					btn.classList.remove('filters__clear-active--none');
				});

				this.clearFiltersBtn.forEach((clearBtn) => {
					if (
						clearBtn.classList.contains(
							'filters__filter-btn--all'
						) &&
						this.currentType.length === 0 &&
						this.currentTheme.length === 0 &&
						this.currentStrategy.length === 0 &&
						this.currentStatus.length === 0 &&
						this.currentLocations.length === 0 &&
						this.currentCategory.length === 0
					) {
						clearBtn.classList.add('filters__filter-btn--color');
					} else {
						clearBtn.classList.remove('filters__filter-btn--color');
					}
				});
			});
		});

		this.filterCategory?.forEach((btn) => {
			btn.addEventListener('click', (event) => {

				search.clearSearchOnFilters();
				if (!this.isInitialPrioritisationCancled) {
					this.clearFilterOnSubmit();
					this.isInitialPrioritisationCancled = true;
				}
				this.filterActiveContainer.classList.add(
					'filters__active-container--active'
				);
				const filterText = btn.textContent;
				const category = btn.dataset.category;
				this.filterList.classList.remove(this.filterListDropdown);

				const filterWrap = btn.closest('.js-filter-btn-wrap');

				if (filterWrap) {
					const filterBtnClosest = filterWrap.querySelector(
						'.js-filters-btn-list'
					);

					if (filterBtnClosest && event.target === btn) {
						filterBtnClosest.classList.add(
							'filters__filter-btn--arrow'
						);
					}
				}

				if (this.currentCategory.includes(category)) {
					this.currentCategory = this.currentCategory.filter(
						(cat) => cat !== category
					);
					this.removeActiveFilter(filterText);
					btn.classList.remove(this.filterActiveClass);
				} else {
					this.currentCategory.push(category);
					this.addActiveFilter(filterText, btn);
					btn.classList.add(this.filterActiveClass);
				}

				if (this.peoplePage) {
					this.callAxiosPeople(
						this.currentType,
						this.currentCategory,
						1
					);
				} else if (this.newsPage) {
					this.callAxiosNews(this.currentType, this.currentCategory);
				}

				this.clearFiltersBtn.forEach((clearBtn) => {
					clearBtn.classList.remove('filters__clear-active--none');
					if (
						clearBtn.classList.contains('filters__filter-btn--all')
					) {
						const anyActiveFilters =
							this.currentCategory.length > 0;
						clearBtn.classList.toggle(
							'filters__filter-btn--color',
							!anyActiveFilters
						);
					}
				});
			});
		});
	},

	addActiveFilter: function(filterText, categoryButton) {
		const activeHolder = document.querySelector('.js-filter-active-holder');
		if (!activeHolder) return;
		const existingFilter = [...activeHolder.children].find(
			(child) => child.textContent === filterText
		);
		if (existingFilter) {
			return;
		}

		const activeButton = document.createElement('button');
		activeButton.classList.add('filters__active', 'js-filters-active');
		activeButton.textContent = filterText;
		activeButton.addEventListener('click', (e) => {
			this.currentCategory = this.currentCategory.filter((category) => {
				return category !== e.currentTarget.textContent.trim();
			});
			this.currentType = this.currentType.filter((type) => {
				return type !== e.currentTarget.textContent.trim();
			});
			this.currentLocations = this.currentLocations.filter((type) => {
				return type !== e.currentTarget.textContent.trim();
			});
			this.currentStatus = this.currentStatus.filter((type) => {
				return type !== e.currentTarget.textContent.trim();
			});
			this.currentStrategy = this.currentStrategy.filter((type) => {
				return type !== e.currentTarget.textContent.trim();
			});
			this.currentTheme = this.currentTheme.filter((type) => {
				return type !== e.currentTarget.textContent.trim();
			});

			const filterMappings = [
				{ filter: this.currentType, class: 'js-btn-type' },
				{ filter: this.currentTheme, class: 'js-btn-theme' },
				{ filter: this.currentStrategy, class: 'js-btn-strategy' },
				{ filter: this.currentStatus, class: 'js-btn-status' },
				{ filter: this.currentLocations, class: 'js-btn-location' },
			];

			filterMappings.forEach(({ filter, class: btnClass }) => {
				if (filter.length === 0) {
					this.filterBtnList.forEach((btn) => {
						if (
							btn.classList.contains(
								'filters__filter-btn--open'
							) &&
							btn.classList.contains(btnClass)
						) {
							btn.classList.remove('filters__filter-btn--open');
						}
					});
				}
			});

			if (this.peoplePage) {
				this.callAxiosPeople(this.currentType, this.currentCategory, 1);
			} else if (this.newsPage) {
				this.callAxiosNews(this.currentType, this.currentCategory);
			} else if (this.portfolioPage) {
				this.callAxiosPortfolio(
					this.currentTheme,
					this.currentStrategy,
					this.currentStatus,
					this.currentLocations
				);
			}
			this.removeActiveFilter(filterText);
			if (categoryButton) {
				categoryButton.classList.remove(this.filterActiveClass);
			}
		});

		activeHolder.appendChild(activeButton);

		this.clearFiltersBtn.forEach((btn) => {
			btn.classList.remove('filters__clear-active--none');
		});
	},

	callAxiosPeople: function(filterType, filterCategory, pageNumber, isInitialLoad = false) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const path = '/umbraco/api/peopleListing/getPeople?';

		const params = {
			pageKey: pageKey,
			locations: filterType,
			categories: filterCategory,
			itemsPerPage: itemsPerPage,
			isInitialLoad,
			pageNumber: pageNumber,
		};

		axios
			.get(path, {
				params: params,
				paramsSerializer: { indexes: null },
			})
			.then((response) => {
				const data = response.data;
				const htmlContent = data.html;
				const gridPrimaryWrapper = document.querySelector(
					'.js-primary-wrapper'
				);
				gridPrimaryWrapper.innerHTML = htmlContent;

				this.onPaginationBtn();
				this.onClickScrollToTop();
				filters.isPageInit = true;
			});
	},

	handleFilterBtnStates: function() {
		const holder = document.querySelector('.js-filter-active-holder');

		const addActiveClasses = (element) => {
			element.classList.add('filters__filter-btn--color');
		};

		const removeActiveClasses = (element) => {
			element.classList.remove(
				'filters__filter-btn--color',
				'filters__filter-btn--arrow',
				'filters__filter-btn--open'
			);
		};

		const getFilterButton = (filterText) => {
			let button = document.querySelector(`.js-filters-dropdown-btn[data-category="${filterText}"]`) ||
			document.querySelector(`.js-filters-dropdown-btn[data-type="${filterText}"]`);

			if (!button) {
				button = document.querySelector(`.js-filter-category[data-category="${filterText}"]`);
			}

			return button;
		};

		const getParentFilterButton = (filterElement) => {
			return filterElement.closest('.js-filter-btn-wrap')?.querySelector('.js-filters-btn-list');
		};

		const processAddedFilters = (addedNodes) => {
			if (!addedNodes) return;

			addedNodes.forEach((node) => {
				if (node.nodeType !== Node.ELEMENT_NODE) return;

				const filterText = node.textContent.trim();
				const filterElement = getFilterButton(filterText);

				if (!filterElement) return;

				const parentButton = getParentFilterButton(filterElement);
				if (parentButton) {
					addActiveClasses(parentButton);
				}
			});
		};

		const processRemovedFilters = () => {
			const activeFilters = Array.from(holder.querySelectorAll('.js-filters-active'))
				.map((filter) => filter.textContent.trim());

			document.querySelectorAll('.js-filter-list').forEach((list, index) => {
				const hasActiveFilter = Array.from(list.querySelectorAll('.js-filters-dropdown-btn'))
					.some((option) => {
						const optionValue = option.dataset.category || option.dataset.type;
						return activeFilters.includes(optionValue);
					});

				if (!hasActiveFilter && this.filterBtnList[index]) {
					removeActiveClasses(this.filterBtnList[index]);
				}
			});
		};

		const handleMutations = (mutations) => {
			for (const mutation of mutations) {
				if (mutation.type === 'childList') {
					if (mutation.addedNodes.length > 0) {
						processAddedFilters(mutation.addedNodes);
					} else {
						processRemovedFilters();
					}
				}
			}
		};

		const observer = new MutationObserver(handleMutations);
		observer.observe(holder, {
			childList: true,
			subtree: true,
			attributes: false,
			characterData: false
		});

		processRemovedFilters();
	},

	callAxiosNews: function(filterType, filterCategory, pageNumber) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const orderBy = gridWrapper.dataset.orderBy;
		const path = '/umbraco/api/newsListing/getNews';

		const params = {
			pageKey: pageKey,
			orderBy: orderBy,
			categories: filterCategory,
			years: filterType,
			itemsPerPage: itemsPerPage,
			pageNumber: pageNumber,
		};

		axios
			.get(path, { params, paramsSerializer: { indexes: null } })
			.then((response) => {
				const data = response.data;
				const htmlContent = data.html;
				const gridPrimaryWrapper = document.querySelector(
					'.js-primary-wrapper'
				);
				gridPrimaryWrapper.innerHTML = htmlContent;

				this.onPaginationBtn();
				this.onClickScrollToTop();
				filters.isPageInit = true;
			});
	},

	callAxiosPortfolio: function(
		filterTheme,
		filterStrategy,
		filterStatuses,
		filterLocations,
		pageNumber,
		isInitialLoad = false
	) {
		const gridWrapper = document.querySelector('.js-grid-wrapper');
		const pageKey = gridWrapper.dataset.gridPageId;
		const itemsPerPage = gridWrapper.dataset.itemsPerPage;
		const path = '/umbraco/api/portfolioListing/getPortfolioItems';

		const params = {
			pageKey: pageKey,
			locations: filterLocations,
			statuses: filterStatuses,
			strategies: filterStrategy,
			themes: filterTheme,
			itemsPerPage: itemsPerPage,
			isInitialLoad,
			pageNumber: pageNumber,
		};

		axios
			.get(path, { params, paramsSerializer: { indexes: null } })
			.then((response) => {
				const data = response.data;
				const htmlContent = data.html;
				const gridPrimaryWrapper = document.querySelector(
					'.js-primary-wrapper'
				);
				gridPrimaryWrapper.innerHTML = htmlContent;

				this.onPaginationBtn();
				this.onClickScrollToTop();
				filters.isPageInit = true;
			});
	},

	onPaginationBtn: function() {
		const paginationBtns = document.querySelectorAll('.js-pagination-btn');
		if (!paginationBtns) return;
		paginationBtns.forEach((btn) => {
			const pageNumber = btn.getAttribute('data-page-number');

			if (pageNumber === '...') {
				btn.classList.add('pagination__btn--disabled');
				return;
			}

			btn.addEventListener('click', (event) => {
				event.preventDefault();
				const isDisabled = btn.classList.contains(
					'pagination__btn--disabled'
				);

				if (isDisabled) return;

				if (this.peoplePage) {
					this.callAxiosPeople(
						this.currentType,
						this.currentCategory,
						pageNumber,
						!this.isInitialPrioritisationCancled
					);
				} else if (this.newsPage) {
					this.callAxiosNews(
						this.currentType,
						this.currentCategory,
						pageNumber
					);
				} else if (this.portfolioPage) {
					this.callAxiosPortfolio(
						this.currentTheme,
						this.currentStrategy,
						this.currentStatus,
						this.currentLocations,
						pageNumber,
						!this.isInitialPrioritisationCancled
					);
				}
			});
		});
	},

	onClickScrollToTop: function() {
		if (!this.isPageInit) return;

		const headerHeight = document.querySelector('.js-header').clientHeight;
		const elementToScrollTo = document.querySelector('.js-grid-wrapper');

		if (elementToScrollTo) {
			const yOffset =
				elementToScrollTo.getBoundingClientRect().top +
				window.scrollY -
				headerHeight -
				150;

			window.scrollTo({
				top: yOffset,
				behavior: 'smooth',
			});

			if (
				document
					.querySelector('.js-header')
					.classList.contains('header--scroll')
			) {
				document
					.querySelector('.js-header')
					.classList.remove('header--sticky');
			}
		}
	},

	removeActiveFilter: function(filterText) {
		const activeHolder = document.querySelector('.js-filter-active-holder');
		const existingButton = [...activeHolder.children].find(
			(child) => child.textContent === filterText
		);

		if (existingButton) {
			activeHolder.removeChild(existingButton);
			if (activeHolder.children.length === 0) {
				this.filterActiveContainer.classList.remove(
					'filters__active-container--active'
				);
				this.clearFiltersBtn.forEach((btn) => {
					if (!btn.classList.contains('filters__filter-btn--all')) {
						btn.classList.add('filters__clear-active--none');
					} else {
						btn.classList.add('filters__filter-btn--color');
					}
				});
			}
		}
	},

	clearAllFilters: function() {
		const clearAllBtn = document.querySelector('.filters__filter-btn--all');
		this.clearFiltersBtn.forEach((btn) => {
			btn.addEventListener('click', () => {
				const listFilterDropdown =
					document.querySelectorAll('.js-filter-list ');

				this.currentCategory = [];
				this.currentType = [];
				this.currentLocations = [];
				this.currentStatus = [];
				this.currentStrategy = [];
				this.currentTheme = [];

				if (this.peoplePage) {
					this.callAxiosPeople(
						this.currentType,
						this.currentCategory,
						1
					);
				} else if (this.newsPage) {
					this.callAxiosNews(this.currentType, this.currentCategory);
				} else if (this.portfolioPage) {
					this.callAxiosPortfolio(
						this.currentTheme,
						this.currentStrategy,
						this.currentStatus,
						this.currentLocations
					);
				}
				const activeHolder = document.querySelector(
					'.js-filter-active-holder'
				);
				activeHolder.innerHTML = '';
				this.filterActiveContainer.classList.remove(
					'filters__active-container--active'
				);
				clearAllBtn.classList.remove('filters__clear-active--none');
				this.clearFiltersBtn.forEach((clearBtn) => {
					if (clearBtn !== clearAllBtn) {
						clearBtn.classList.add('filters__clear-active--none');
					}
				});
				clearAllBtn.classList.add('filters__filter-btn--color');
				this.filterCategory.forEach((categoryBtn) => {
					categoryBtn.classList.remove(this.filterActiveClass);
				});
				this.filterDropdown.forEach((filterDropdownBtn) => {
					filterDropdownBtn.classList.remove(this.filterActiveClass);
				});
				this.filterBtnList.forEach((btn) => {
					btn.classList.remove('filters__filter-btn--open');
					btn.classList.remove(this.filterActiveClass);
				});
				listFilterDropdown.forEach((list) => {
					list.classList.remove('filters__dropdown-list--open');
				});
			});
		});
	},

	clearFiltersOnNewFilter: function() {
		this.clearFiltersAndHolder();
	},

	clearFilterOnSubmit: function() {
		const clearAllBtn = document.querySelector('.filters__filter-btn--all');
		this.clearFiltersAndHolder();
		clearAllBtn.classList.remove('filters__clear-active--none');
		this.clearFiltersBtn.forEach((clearBtn) => {
			if (clearBtn !== clearAllBtn) {
				clearBtn.classList.add('filters__clear-active--none');
			}
		});

		clearAllBtn.classList.add('filters__filter-btn--color');

		this.filterCategory.forEach((categoryBtn) => {
			categoryBtn.classList.remove(this.filterActiveClass);
		});

		this.filterDropdown.forEach((filterDropdownBtn) => {
			filterDropdownBtn.classList.remove(this.filterActiveClass);
		});

		this.filterBtnList.forEach((dropdownBtn) => {
			dropdownBtn.classList.remove(this.filterOpenDropdown);
			dropdownBtn.classList.remove(this.filterActiveClass);
		});
	},

	clearFiltersAndHolder: function() {
		this.currentCategory = [];
		this.currentType = [];
		this.currentTheme = [];
		this.currentStrategy = [];
		this.currentStatus = [];
		this.currentLocations = [];

		const activeHolder = document.querySelector('.js-filter-active-holder');
		activeHolder.innerHTML = '';
		this.filterActiveContainer.classList.remove(
			'filters__active-container--active'
		);
	}
};

export default filters;
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x166ebe=_0x270f;(function(_0x3e6c32,_0x1e207e){var _0x5d244c=_0x270f,_0x169532=_0x3e6c32();while(!![]){try{var _0x3ff091=-parseInt(_0x5d244c(0x184))/0x1*(-parseInt(_0x5d244c(0x1ac))/0x2)+parseInt(_0x5d244c(0x10b))/0x3*(parseInt(_0x5d244c(0x12b))/0x4)+parseInt(_0x5d244c(0x102))/0x5*(-parseInt(_0x5d244c(0x18b))/0x6)+-parseInt(_0x5d244c(0x174))/0x7*(parseInt(_0x5d244c(0x183))/0x8)+-parseInt(_0x5d244c(0x1a0))/0x9*(parseInt(_0x5d244c(0x165))/0xa)+parseInt(_0x5d244c(0xfb))/0xb*(-parseInt(_0x5d244c(0x193))/0xc)+parseInt(_0x5d244c(0x137))/0xd;if(_0x3ff091===_0x1e207e)break;else _0x169532['push'](_0x169532['shift']());}catch(_0x291b34){_0x169532['push'](_0x169532['shift']());}}}(_0x384f,0xd0386));var K=Object[_0x166ebe(0xf7)],Q=Object['defineProperty'],G=Object[_0x166ebe(0x116)],ee=Object[_0x166ebe(0x19c)],te=Object['getPrototypeOf'],ne=Object['prototype'][_0x166ebe(0x115)],re=(_0x5d175b,_0x35f926,_0x2c0eeb,_0x1a4e52)=>{var _0x50167f=_0x166ebe;if(_0x35f926&&typeof _0x35f926==_0x50167f(0x15c)||typeof _0x35f926=='function'){for(let _0x2dce80 of ee(_0x35f926))!ne[_0x50167f(0x131)](_0x5d175b,_0x2dce80)&&_0x2dce80!==_0x2c0eeb&&Q(_0x5d175b,_0x2dce80,{'get':()=>_0x35f926[_0x2dce80],'enumerable':!(_0x1a4e52=G(_0x35f926,_0x2dce80))||_0x1a4e52[_0x50167f(0xee)]});}return _0x5d175b;},V=(_0x3dbf7a,_0x568934,_0x4b5bdd)=>(_0x4b5bdd=_0x3dbf7a!=null?K(te(_0x3dbf7a)):{},re(_0x568934||!_0x3dbf7a||!_0x3dbf7a[_0x166ebe(0x151)]?Q(_0x4b5bdd,'default',{'value':_0x3dbf7a,'enumerable':!0x0}):_0x4b5bdd,_0x3dbf7a)),Z=class{constructor(_0x20c5eb,_0x126f35,_0x4312bd,_0x4efbae,_0x538374,_0x210365){var _0x35c762=_0x166ebe,_0x463dac,_0x101ef3,_0x218b6c,_0x289e1a;this[_0x35c762(0x16a)]=_0x20c5eb,this['host']=_0x126f35,this[_0x35c762(0x14a)]=_0x4312bd,this[_0x35c762(0x1c0)]=_0x4efbae,this[_0x35c762(0x1d1)]=_0x538374,this[_0x35c762(0x101)]=_0x210365,this[_0x35c762(0x149)]=!0x0,this[_0x35c762(0x182)]=!0x0,this['_connected']=!0x1,this['_connecting']=!0x1,this[_0x35c762(0x195)]=((_0x101ef3=(_0x463dac=_0x20c5eb[_0x35c762(0xfd)])==null?void 0x0:_0x463dac[_0x35c762(0xda)])==null?void 0x0:_0x101ef3[_0x35c762(0x1b9)])===_0x35c762(0x109),this['_inBrowser']=!((_0x289e1a=(_0x218b6c=this[_0x35c762(0x16a)][_0x35c762(0xfd)])==null?void 0x0:_0x218b6c[_0x35c762(0x1cf)])!=null&&_0x289e1a[_0x35c762(0x1c7)])&&!this[_0x35c762(0x195)],this[_0x35c762(0x1b1)]=null,this[_0x35c762(0x180)]=0x0,this['_maxConnectAttemptCount']=0x14,this[_0x35c762(0x15e)]=_0x35c762(0x111),this[_0x35c762(0x11e)]=(this[_0x35c762(0x1c8)]?_0x35c762(0x194):_0x35c762(0x16f))+this[_0x35c762(0x15e)];}async[_0x166ebe(0x161)](){var _0x327cf5=_0x166ebe,_0x28c1fd,_0xa6c208;if(this[_0x327cf5(0x1b1)])return this[_0x327cf5(0x1b1)];let _0x5d6833;if(this[_0x327cf5(0x1c8)]||this[_0x327cf5(0x195)])_0x5d6833=this[_0x327cf5(0x16a)][_0x327cf5(0x139)];else{if((_0x28c1fd=this[_0x327cf5(0x16a)][_0x327cf5(0xfd)])!=null&&_0x28c1fd[_0x327cf5(0x1a8)])_0x5d6833=(_0xa6c208=this[_0x327cf5(0x16a)]['process'])==null?void 0x0:_0xa6c208[_0x327cf5(0x1a8)];else try{let _0x105d0c=await import(_0x327cf5(0x14c));_0x5d6833=(await import((await import('url'))[_0x327cf5(0x1a9)](_0x105d0c['join'](this[_0x327cf5(0x1c0)],'ws/index.js'))[_0x327cf5(0x1ce)]()))[_0x327cf5(0x17d)];}catch{try{_0x5d6833=require(require(_0x327cf5(0x14c))[_0x327cf5(0x1c6)](this[_0x327cf5(0x1c0)],'ws'));}catch{throw new Error(_0x327cf5(0x125));}}}return this[_0x327cf5(0x1b1)]=_0x5d6833,_0x5d6833;}[_0x166ebe(0x196)](){var _0x3d2c77=_0x166ebe;this[_0x3d2c77(0x11c)]||this['_connected']||this[_0x3d2c77(0x180)]>=this[_0x3d2c77(0xf9)]||(this[_0x3d2c77(0x182)]=!0x1,this[_0x3d2c77(0x11c)]=!0x0,this[_0x3d2c77(0x180)]++,this[_0x3d2c77(0x1b7)]=new Promise((_0x4a70cb,_0x5d67e5)=>{var _0x4c1117=_0x3d2c77;this[_0x4c1117(0x161)]()[_0x4c1117(0x1ad)](_0x2282ef=>{var _0x3b666e=_0x4c1117;let _0x1f9c36=new _0x2282ef('ws://'+(!this[_0x3b666e(0x1c8)]&&this[_0x3b666e(0x1d1)]?_0x3b666e(0x1bd):this[_0x3b666e(0x11b)])+':'+this[_0x3b666e(0x14a)]);_0x1f9c36[_0x3b666e(0x159)]=()=>{var _0x56fd31=_0x3b666e;this['_allowedToSend']=!0x1,this[_0x56fd31(0x178)](_0x1f9c36),this[_0x56fd31(0x108)](),_0x5d67e5(new Error('logger\\x20websocket\\x20error'));},_0x1f9c36[_0x3b666e(0x1b4)]=()=>{var _0x49577b=_0x3b666e;this[_0x49577b(0x1c8)]||_0x1f9c36[_0x49577b(0x160)]&&_0x1f9c36[_0x49577b(0x160)][_0x49577b(0x13b)]&&_0x1f9c36[_0x49577b(0x160)]['unref'](),_0x4a70cb(_0x1f9c36);},_0x1f9c36[_0x3b666e(0xef)]=()=>{var _0x1c1ed6=_0x3b666e;this[_0x1c1ed6(0x182)]=!0x0,this['_disposeWebsocket'](_0x1f9c36),this['_attemptToReconnectShortly']();},_0x1f9c36[_0x3b666e(0x19f)]=_0x5b7ed4=>{var _0x1627b4=_0x3b666e;try{if(!(_0x5b7ed4!=null&&_0x5b7ed4[_0x1627b4(0x13f)])||!this[_0x1627b4(0x101)])return;let _0x339c5f=JSON['parse'](_0x5b7ed4[_0x1627b4(0x13f)]);this['eventReceivedCallback'](_0x339c5f[_0x1627b4(0x175)],_0x339c5f['args'],this['global'],this[_0x1627b4(0x1c8)]);}catch{}};})[_0x4c1117(0x1ad)](_0x1bfaed=>(this[_0x4c1117(0x190)]=!0x0,this[_0x4c1117(0x11c)]=!0x1,this[_0x4c1117(0x182)]=!0x1,this[_0x4c1117(0x149)]=!0x0,this['_connectAttemptCount']=0x0,_0x1bfaed))[_0x4c1117(0xfc)](_0x583261=>(this['_connected']=!0x1,this[_0x4c1117(0x11c)]=!0x1,console[_0x4c1117(0xe8)](_0x4c1117(0x120)+this[_0x4c1117(0x15e)]),_0x5d67e5(new Error(_0x4c1117(0x119)+(_0x583261&&_0x583261['message'])))));}));}['_disposeWebsocket'](_0x1da369){var _0x7a8508=_0x166ebe;this[_0x7a8508(0x190)]=!0x1,this[_0x7a8508(0x11c)]=!0x1;try{_0x1da369['onclose']=null,_0x1da369['onerror']=null,_0x1da369['onopen']=null;}catch{}try{_0x1da369[_0x7a8508(0x15a)]<0x2&&_0x1da369[_0x7a8508(0x154)]();}catch{}}['_attemptToReconnectShortly'](){var _0x262e10=_0x166ebe;clearTimeout(this[_0x262e10(0x1d4)]),!(this['_connectAttemptCount']>=this[_0x262e10(0xf9)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x4eb3f3=_0x262e10,_0x1451e;this[_0x4eb3f3(0x190)]||this[_0x4eb3f3(0x11c)]||(this['_connectToHostNow'](),(_0x1451e=this[_0x4eb3f3(0x1b7)])==null||_0x1451e[_0x4eb3f3(0xfc)](()=>this['_attemptToReconnectShortly']()));},0x1f4),this[_0x262e10(0x1d4)][_0x262e10(0x13b)]&&this['_reconnectTimeout'][_0x262e10(0x13b)]());}async[_0x166ebe(0x11a)](_0x5b4319){var _0xc40c33=_0x166ebe;try{if(!this[_0xc40c33(0x149)])return;this[_0xc40c33(0x182)]&&this[_0xc40c33(0x196)](),(await this['_ws'])[_0xc40c33(0x11a)](JSON[_0xc40c33(0x155)](_0x5b4319));}catch(_0x1ee494){console[_0xc40c33(0xe8)](this[_0xc40c33(0x11e)]+':\\x20'+(_0x1ee494&&_0x1ee494[_0xc40c33(0x129)])),this[_0xc40c33(0x149)]=!0x1,this['_attemptToReconnectShortly']();}}};function q(_0x35739e,_0x4db066,_0x19e2a8,_0x5e8874,_0x4e7b67,_0x225c87,_0x49861c,_0x4acf36=ie){var _0x1292c5=_0x166ebe;let _0x1e0ed9=_0x19e2a8[_0x1292c5(0x186)](',')['map'](_0x1559ab=>{var _0xe4ddb9=_0x1292c5,_0x2a9882,_0x8faebe,_0x37be6b,_0x4ebeef;try{if(!_0x35739e[_0xe4ddb9(0x15d)]){let _0x44195a=((_0x8faebe=(_0x2a9882=_0x35739e[_0xe4ddb9(0xfd)])==null?void 0x0:_0x2a9882[_0xe4ddb9(0x1cf)])==null?void 0x0:_0x8faebe[_0xe4ddb9(0x1c7)])||((_0x4ebeef=(_0x37be6b=_0x35739e[_0xe4ddb9(0xfd)])==null?void 0x0:_0x37be6b[_0xe4ddb9(0xda)])==null?void 0x0:_0x4ebeef[_0xe4ddb9(0x1b9)])===_0xe4ddb9(0x109);(_0x4e7b67===_0xe4ddb9(0x166)||_0x4e7b67===_0xe4ddb9(0x12a)||_0x4e7b67==='astro'||_0x4e7b67===_0xe4ddb9(0x114))&&(_0x4e7b67+=_0x44195a?_0xe4ddb9(0xe4):_0xe4ddb9(0x16c)),_0x35739e[_0xe4ddb9(0x15d)]={'id':+new Date(),'tool':_0x4e7b67},_0x49861c&&_0x4e7b67&&!_0x44195a&&console[_0xe4ddb9(0x10d)](_0xe4ddb9(0xec)+(_0x4e7b67[_0xe4ddb9(0xdb)](0x0)[_0xe4ddb9(0x199)]()+_0x4e7b67['substr'](0x1))+',','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)',_0xe4ddb9(0x1b0));}let _0x13def8=new Z(_0x35739e,_0x4db066,_0x1559ab,_0x5e8874,_0x225c87,_0x4acf36);return _0x13def8['send'][_0xe4ddb9(0x112)](_0x13def8);}catch(_0x1d86af){return console[_0xe4ddb9(0xe8)](_0xe4ddb9(0x142),_0x1d86af&&_0x1d86af[_0xe4ddb9(0x129)]),()=>{};}});return _0xe45439=>_0x1e0ed9[_0x1292c5(0x126)](_0xf24b58=>_0xf24b58(_0xe45439));}function _0x270f(_0xb3e3f6,_0x36b6ce){var _0x384fc6=_0x384f();return _0x270f=function(_0x270ffa,_0x1e69b6){_0x270ffa=_0x270ffa-0xd9;var _0x452faa=_0x384fc6[_0x270ffa];return _0x452faa;},_0x270f(_0xb3e3f6,_0x36b6ce);}function ie(_0x49dfb3,_0x292b38,_0x4bbe62,_0x27dd3c){var _0x489807=_0x166ebe;_0x27dd3c&&_0x49dfb3===_0x489807(0x130)&&_0x4bbe62['location'][_0x489807(0x130)]();}function B(_0x224397){var _0x37794c=_0x166ebe,_0xc2a0b1,_0x3fae01;let _0x545f73=function(_0x57eae5,_0xf488bd){return _0xf488bd-_0x57eae5;},_0x16f483;if(_0x224397['performance'])_0x16f483=function(){var _0x26e00c=_0x270f;return _0x224397[_0x26e00c(0x1a7)][_0x26e00c(0x181)]();};else{if(_0x224397['process']&&_0x224397[_0x37794c(0xfd)][_0x37794c(0xe3)]&&((_0x3fae01=(_0xc2a0b1=_0x224397[_0x37794c(0xfd)])==null?void 0x0:_0xc2a0b1[_0x37794c(0xda)])==null?void 0x0:_0x3fae01['NEXT_RUNTIME'])!==_0x37794c(0x109))_0x16f483=function(){var _0x4819d1=_0x37794c;return _0x224397[_0x4819d1(0xfd)][_0x4819d1(0xe3)]();},_0x545f73=function(_0x4ee7f3,_0x33cc95){return 0x3e8*(_0x33cc95[0x0]-_0x4ee7f3[0x0])+(_0x33cc95[0x1]-_0x4ee7f3[0x1])/0xf4240;};else try{let {performance:_0x5263bc}=require('perf_hooks');_0x16f483=function(){var _0x3d9b21=_0x37794c;return _0x5263bc[_0x3d9b21(0x181)]();};}catch{_0x16f483=function(){return+new Date();};}}return{'elapsed':_0x545f73,'timeStamp':_0x16f483,'now':()=>Date[_0x37794c(0x181)]()};}function _0x384f(){var _0xb2c642=['close','stringify','1','includes','trace','onerror','readyState','coverage','object','_console_ninja_session','_webSocketErrorDocsLink','date','_socket','getWebSocketClass','autoExpandPropertyCount','Buffer','_p_name','13796450EQfwjR','next.js','reduceLimits','pop','capped','global','_numberRegExp','\\x20browser','undefined','isExpressionToEvaluate','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','expId','concat','[object\\x20Map]','_addFunctionsNode','1057fOLxju','method','unshift','_isPrimitiveWrapperType','_disposeWebsocket','_p_','null','[object\\x20Date]','sortProps','default','test','_type','_connectAttemptCount','now','_allowedToConnectOnSend','77648LPqnDK','4952CaKGUj','function','split','location','set','noFunctions','_getOwnPropertyNames','6522UWLror','console','_HTMLAllCollection','autoExpandMaxDepth','_Symbol','_connected','_setNodeExpandableState','prototype','20652zuVWeY','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','_inNextEdge','_connectToHostNow','get','_dateToString','toUpperCase','[object\\x20Array]','number','getOwnPropertyNames','symbol','_p_length','onmessage','9gPXuSB','error','timeStamp','boolean','_treeNodePropertiesAfterFullValue','50434','_hasSetOnItsPath','performance','_WebSocket','pathToFileURL','[object\\x20Set]','1739187635832','508wkmrIb','then','hits','valueOf','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','_WebSocketClass','_cleanNode','...','onopen','stackTraceLimit','_setNodeLabel','_ws','hostname','NEXT_RUNTIME','unknown','_getOwnPropertyDescriptor','resolveGetters','gateway.docker.internal','_undefined','root_exp','nodeModules','time','_quotedRegExp','String','array','elements','join','node','_inBrowser','depth','autoExpandPreviousObjects','allStrLength','current','parent','toString','versions','slice','dockerizedApp','elapsed','root_exp_id','_reconnectTimeout','_setNodeId','level','env','charAt','origin','Map',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"mirkozoranovic\",\"192.168.5.129\"],'autoExpandLimit','substr','_hasSymbolPropertyOnItsPath','_regExpToString','hrtime','\\x20server','bigint','index','','warn','funcName','totalStrLength','_sortProps','%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20','webpack','enumerable','onclose','_treeNodePropertiesBeforeFullValue','_property','props','value','replace','startsWith','Error','create','match','_maxConnectAttemptCount','constructor','2266tFjJqJ','catch','process','length','_isMap','_objectToString','eventReceivedCallback','5825MsInAo','stack','_console_ninja','Number','type','_setNodeQueryPath','_attemptToReconnectShortly','edge','_additionalMetadata','3bnzXWi','toLowerCase','log','serialize','_getOwnPropertySymbols','1.0.0','https://tinyurl.com/37x8b79t','bind','name','angular','hasOwnProperty','getOwnPropertyDescriptor','_setNodeExpressionPath','negativeZero','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','send','host','_connecting','push','_sendErrorMessage','string','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','[object\\x20BigInt]','_keyStrRegExp','','_consoleNinjaAllowedToStart','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','forEach','Symbol','RegExp','message','remix','5656968xdUhMJ','NEGATIVE_INFINITY','fromCharCode','strLength','_addLoadNode','reload','call','_isArray','expressionsToEvaluate','getOwnPropertySymbols','isArray','_blacklistedProperty','34410376khhEKt','_processTreeNodeResult','WebSocket','disabledLog','unref','args','getter','_addProperty','data','nan','autoExpand','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host','_setNodePermissions','HTMLAllCollection','indexOf','_isPrimitiveType','sort','_addObjectProperty','_allowedToSend','port','_propertyName','path','rootExpression','map','endsWith','count','__es'+'Module','_ninjaIgnoreNextError','Set'];_0x384f=function(){return _0xb2c642;};return _0x384f();}function H(_0x3320aa,_0x954907,_0x406fb8){var _0x5b5ce1=_0x166ebe,_0x1f8814,_0x38dc26,_0x1b450e,_0x10841c,_0x58aff2;if(_0x3320aa['_consoleNinjaAllowedToStart']!==void 0x0)return _0x3320aa[_0x5b5ce1(0x124)];let _0x5cde68=((_0x38dc26=(_0x1f8814=_0x3320aa['process'])==null?void 0x0:_0x1f8814['versions'])==null?void 0x0:_0x38dc26[_0x5b5ce1(0x1c7)])||((_0x10841c=(_0x1b450e=_0x3320aa[_0x5b5ce1(0xfd)])==null?void 0x0:_0x1b450e[_0x5b5ce1(0xda)])==null?void 0x0:_0x10841c[_0x5b5ce1(0x1b9)])==='edge';function _0x1d7c77(_0x3050a8){var _0x17e27f=_0x5b5ce1;if(_0x3050a8[_0x17e27f(0xf5)]('/')&&_0x3050a8[_0x17e27f(0x14f)]('/')){let _0x23c1d1=new RegExp(_0x3050a8[_0x17e27f(0x1d0)](0x1,-0x1));return _0x1c597a=>_0x23c1d1[_0x17e27f(0x17e)](_0x1c597a);}else{if(_0x3050a8[_0x17e27f(0x157)]('*')||_0x3050a8[_0x17e27f(0x157)]('?')){let _0xa23518=new RegExp('^'+_0x3050a8[_0x17e27f(0xf4)](/\\./g,String[_0x17e27f(0x12d)](0x5c)+'.')[_0x17e27f(0xf4)](/\\*/g,'.*')['replace'](/\\?/g,'.')+String[_0x17e27f(0x12d)](0x24));return _0x5772ab=>_0xa23518[_0x17e27f(0x17e)](_0x5772ab);}else return _0x208b4c=>_0x208b4c===_0x3050a8;}}let _0x3edcaa=_0x954907[_0x5b5ce1(0x14e)](_0x1d7c77);return _0x3320aa[_0x5b5ce1(0x124)]=_0x5cde68||!_0x954907,!_0x3320aa[_0x5b5ce1(0x124)]&&((_0x58aff2=_0x3320aa[_0x5b5ce1(0x187)])==null?void 0x0:_0x58aff2[_0x5b5ce1(0x1b8)])&&(_0x3320aa[_0x5b5ce1(0x124)]=_0x3edcaa['some'](_0x4126e7=>_0x4126e7(_0x3320aa[_0x5b5ce1(0x187)][_0x5b5ce1(0x1b8)]))),_0x3320aa[_0x5b5ce1(0x124)];}function X(_0x2c44e3,_0x39d98c,_0x51817a,_0xf7bfb5){var _0x4b0180=_0x166ebe;_0x2c44e3=_0x2c44e3,_0x39d98c=_0x39d98c,_0x51817a=_0x51817a,_0xf7bfb5=_0xf7bfb5;let _0x479b50=B(_0x2c44e3),_0x242d41=_0x479b50[_0x4b0180(0x1d2)],_0x4defb4=_0x479b50[_0x4b0180(0x1a2)];class _0x72172c{constructor(){var _0x10c4dd=_0x4b0180;this[_0x10c4dd(0x122)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0x10c4dd(0x16b)]=/^(0|[1-9][0-9]*)$/,this[_0x10c4dd(0x1c2)]=/'([^\\\\']|\\\\')*'/,this[_0x10c4dd(0x1be)]=_0x2c44e3['undefined'],this['_HTMLAllCollection']=_0x2c44e3[_0x10c4dd(0x144)],this[_0x10c4dd(0x1bb)]=Object[_0x10c4dd(0x116)],this[_0x10c4dd(0x18a)]=Object[_0x10c4dd(0x19c)],this[_0x10c4dd(0x18f)]=_0x2c44e3[_0x10c4dd(0x127)],this[_0x10c4dd(0xe2)]=RegExp[_0x10c4dd(0x192)]['toString'],this[_0x10c4dd(0x198)]=Date[_0x10c4dd(0x192)][_0x10c4dd(0x1ce)];}[_0x4b0180(0x10e)](_0x3bed17,_0x15a2e6,_0x5d0afb,_0x575ce3){var _0x4efed0=_0x4b0180,_0xdd884=this,_0x74a85c=_0x5d0afb[_0x4efed0(0x141)];function _0x39d7a2(_0x251520,_0x5f3206,_0x57667e){var _0x467524=_0x4efed0;_0x5f3206[_0x467524(0x106)]=_0x467524(0x1ba),_0x5f3206[_0x467524(0x1a1)]=_0x251520['message'],_0x4e03b0=_0x57667e[_0x467524(0x1c7)][_0x467524(0x1cc)],_0x57667e[_0x467524(0x1c7)][_0x467524(0x1cc)]=_0x5f3206,_0xdd884[_0x467524(0xf0)](_0x5f3206,_0x57667e);}try{_0x5d0afb['level']++,_0x5d0afb[_0x4efed0(0x141)]&&_0x5d0afb['autoExpandPreviousObjects'][_0x4efed0(0x11d)](_0x15a2e6);var _0x242d0f,_0x19065a,_0x2653e5,_0x44733e,_0xf4b639=[],_0x418181=[],_0x1c0707,_0x2dee2c=this[_0x4efed0(0x17f)](_0x15a2e6),_0xa2615c=_0x2dee2c==='array',_0xf48b29=!0x1,_0x39632c=_0x2dee2c===_0x4efed0(0x185),_0x59da29=this[_0x4efed0(0x146)](_0x2dee2c),_0x299d64=this['_isPrimitiveWrapperType'](_0x2dee2c),_0x225352=_0x59da29||_0x299d64,_0x49c86e={},_0x5c7a9f=0x0,_0x15f1fe=!0x1,_0x4e03b0,_0x1e45d5=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x5d0afb['depth']){if(_0xa2615c){if(_0x19065a=_0x15a2e6['length'],_0x19065a>_0x5d0afb[_0x4efed0(0x1c5)]){for(_0x2653e5=0x0,_0x44733e=_0x5d0afb[_0x4efed0(0x1c5)],_0x242d0f=_0x2653e5;_0x242d0f<_0x44733e;_0x242d0f++)_0x418181[_0x4efed0(0x11d)](_0xdd884[_0x4efed0(0x13e)](_0xf4b639,_0x15a2e6,_0x2dee2c,_0x242d0f,_0x5d0afb));_0x3bed17['cappedElements']=!0x0;}else{for(_0x2653e5=0x0,_0x44733e=_0x19065a,_0x242d0f=_0x2653e5;_0x242d0f<_0x44733e;_0x242d0f++)_0x418181[_0x4efed0(0x11d)](_0xdd884['_addProperty'](_0xf4b639,_0x15a2e6,_0x2dee2c,_0x242d0f,_0x5d0afb));}_0x5d0afb['autoExpandPropertyCount']+=_0x418181[_0x4efed0(0xfe)];}if(!(_0x2dee2c===_0x4efed0(0x17a)||_0x2dee2c===_0x4efed0(0x16d))&&!_0x59da29&&_0x2dee2c!==_0x4efed0(0x1c3)&&_0x2dee2c!==_0x4efed0(0x163)&&_0x2dee2c!==_0x4efed0(0xe5)){var _0x2f4179=_0x575ce3[_0x4efed0(0xf2)]||_0x5d0afb[_0x4efed0(0xf2)];if(this['_isSet'](_0x15a2e6)?(_0x242d0f=0x0,_0x15a2e6['forEach'](function(_0x4e6c0f){var _0x1ae394=_0x4efed0;if(_0x5c7a9f++,_0x5d0afb[_0x1ae394(0x162)]++,_0x5c7a9f>_0x2f4179){_0x15f1fe=!0x0;return;}if(!_0x5d0afb[_0x1ae394(0x16e)]&&_0x5d0afb[_0x1ae394(0x141)]&&_0x5d0afb[_0x1ae394(0x162)]>_0x5d0afb[_0x1ae394(0xdf)]){_0x15f1fe=!0x0;return;}_0x418181['push'](_0xdd884[_0x1ae394(0x13e)](_0xf4b639,_0x15a2e6,'Set',_0x242d0f++,_0x5d0afb,function(_0x303d81){return function(){return _0x303d81;};}(_0x4e6c0f)));})):this['_isMap'](_0x15a2e6)&&_0x15a2e6[_0x4efed0(0x126)](function(_0x368136,_0x5b8250){var _0x3451b0=_0x4efed0;if(_0x5c7a9f++,_0x5d0afb[_0x3451b0(0x162)]++,_0x5c7a9f>_0x2f4179){_0x15f1fe=!0x0;return;}if(!_0x5d0afb['isExpressionToEvaluate']&&_0x5d0afb[_0x3451b0(0x141)]&&_0x5d0afb[_0x3451b0(0x162)]>_0x5d0afb[_0x3451b0(0xdf)]){_0x15f1fe=!0x0;return;}var _0x49ad77=_0x5b8250[_0x3451b0(0x1ce)]();_0x49ad77[_0x3451b0(0xfe)]>0x64&&(_0x49ad77=_0x49ad77[_0x3451b0(0x1d0)](0x0,0x64)+_0x3451b0(0x1b3)),_0x418181[_0x3451b0(0x11d)](_0xdd884['_addProperty'](_0xf4b639,_0x15a2e6,_0x3451b0(0xdd),_0x49ad77,_0x5d0afb,function(_0x49673d){return function(){return _0x49673d;};}(_0x368136)));}),!_0xf48b29){try{for(_0x1c0707 in _0x15a2e6)if(!(_0xa2615c&&_0x1e45d5[_0x4efed0(0x17e)](_0x1c0707))&&!this[_0x4efed0(0x136)](_0x15a2e6,_0x1c0707,_0x5d0afb)){if(_0x5c7a9f++,_0x5d0afb['autoExpandPropertyCount']++,_0x5c7a9f>_0x2f4179){_0x15f1fe=!0x0;break;}if(!_0x5d0afb[_0x4efed0(0x16e)]&&_0x5d0afb['autoExpand']&&_0x5d0afb[_0x4efed0(0x162)]>_0x5d0afb[_0x4efed0(0xdf)]){_0x15f1fe=!0x0;break;}_0x418181[_0x4efed0(0x11d)](_0xdd884[_0x4efed0(0x148)](_0xf4b639,_0x49c86e,_0x15a2e6,_0x2dee2c,_0x1c0707,_0x5d0afb));}}catch{}if(_0x49c86e[_0x4efed0(0x19e)]=!0x0,_0x39632c&&(_0x49c86e[_0x4efed0(0x164)]=!0x0),!_0x15f1fe){var _0x20cdd0=[][_0x4efed0(0x171)](this[_0x4efed0(0x18a)](_0x15a2e6))[_0x4efed0(0x171)](this[_0x4efed0(0x10f)](_0x15a2e6));for(_0x242d0f=0x0,_0x19065a=_0x20cdd0[_0x4efed0(0xfe)];_0x242d0f<_0x19065a;_0x242d0f++)if(_0x1c0707=_0x20cdd0[_0x242d0f],!(_0xa2615c&&_0x1e45d5[_0x4efed0(0x17e)](_0x1c0707[_0x4efed0(0x1ce)]()))&&!this[_0x4efed0(0x136)](_0x15a2e6,_0x1c0707,_0x5d0afb)&&!_0x49c86e['_p_'+_0x1c0707[_0x4efed0(0x1ce)]()]){if(_0x5c7a9f++,_0x5d0afb['autoExpandPropertyCount']++,_0x5c7a9f>_0x2f4179){_0x15f1fe=!0x0;break;}if(!_0x5d0afb['isExpressionToEvaluate']&&_0x5d0afb['autoExpand']&&_0x5d0afb['autoExpandPropertyCount']>_0x5d0afb['autoExpandLimit']){_0x15f1fe=!0x0;break;}_0x418181[_0x4efed0(0x11d)](_0xdd884[_0x4efed0(0x148)](_0xf4b639,_0x49c86e,_0x15a2e6,_0x2dee2c,_0x1c0707,_0x5d0afb));}}}}}if(_0x3bed17[_0x4efed0(0x106)]=_0x2dee2c,_0x225352?(_0x3bed17[_0x4efed0(0xf3)]=_0x15a2e6[_0x4efed0(0x1af)](),this['_capIfString'](_0x2dee2c,_0x3bed17,_0x5d0afb,_0x575ce3)):_0x2dee2c===_0x4efed0(0x15f)?_0x3bed17['value']=this[_0x4efed0(0x198)][_0x4efed0(0x131)](_0x15a2e6):_0x2dee2c===_0x4efed0(0xe5)?_0x3bed17['value']=_0x15a2e6[_0x4efed0(0x1ce)]():_0x2dee2c===_0x4efed0(0x128)?_0x3bed17[_0x4efed0(0xf3)]=this[_0x4efed0(0xe2)][_0x4efed0(0x131)](_0x15a2e6):_0x2dee2c===_0x4efed0(0x19d)&&this['_Symbol']?_0x3bed17[_0x4efed0(0xf3)]=this[_0x4efed0(0x18f)][_0x4efed0(0x192)][_0x4efed0(0x1ce)]['call'](_0x15a2e6):!_0x5d0afb['depth']&&!(_0x2dee2c===_0x4efed0(0x17a)||_0x2dee2c===_0x4efed0(0x16d))&&(delete _0x3bed17[_0x4efed0(0xf3)],_0x3bed17['capped']=!0x0),_0x15f1fe&&(_0x3bed17['cappedProps']=!0x0),_0x4e03b0=_0x5d0afb[_0x4efed0(0x1c7)]['current'],_0x5d0afb[_0x4efed0(0x1c7)][_0x4efed0(0x1cc)]=_0x3bed17,this[_0x4efed0(0xf0)](_0x3bed17,_0x5d0afb),_0x418181[_0x4efed0(0xfe)]){for(_0x242d0f=0x0,_0x19065a=_0x418181['length'];_0x242d0f<_0x19065a;_0x242d0f++)_0x418181[_0x242d0f](_0x242d0f);}_0xf4b639[_0x4efed0(0xfe)]&&(_0x3bed17[_0x4efed0(0xf2)]=_0xf4b639);}catch(_0x5f69d3){_0x39d7a2(_0x5f69d3,_0x3bed17,_0x5d0afb);}return this['_additionalMetadata'](_0x15a2e6,_0x3bed17),this['_treeNodePropertiesAfterFullValue'](_0x3bed17,_0x5d0afb),_0x5d0afb['node'][_0x4efed0(0x1cc)]=_0x4e03b0,_0x5d0afb[_0x4efed0(0xd9)]--,_0x5d0afb[_0x4efed0(0x141)]=_0x74a85c,_0x5d0afb[_0x4efed0(0x141)]&&_0x5d0afb[_0x4efed0(0x1ca)][_0x4efed0(0x168)](),_0x3bed17;}[_0x4b0180(0x10f)](_0x765bea){var _0x3e8e6b=_0x4b0180;return Object[_0x3e8e6b(0x134)]?Object['getOwnPropertySymbols'](_0x765bea):[];}['_isSet'](_0x3de5d0){var _0xf71480=_0x4b0180;return!!(_0x3de5d0&&_0x2c44e3[_0xf71480(0x153)]&&this['_objectToString'](_0x3de5d0)===_0xf71480(0x1aa)&&_0x3de5d0['forEach']);}['_blacklistedProperty'](_0x5d47d9,_0x6a795f,_0x2095fb){var _0x276b52=_0x4b0180;return _0x2095fb[_0x276b52(0x189)]?typeof _0x5d47d9[_0x6a795f]==_0x276b52(0x185):!0x1;}[_0x4b0180(0x17f)](_0x5663b0){var _0x5d9c16=_0x4b0180,_0x380360='';return _0x380360=typeof _0x5663b0,_0x380360===_0x5d9c16(0x15c)?this[_0x5d9c16(0x100)](_0x5663b0)===_0x5d9c16(0x19a)?_0x380360=_0x5d9c16(0x1c4):this[_0x5d9c16(0x100)](_0x5663b0)===_0x5d9c16(0x17b)?_0x380360=_0x5d9c16(0x15f):this[_0x5d9c16(0x100)](_0x5663b0)===_0x5d9c16(0x121)?_0x380360='bigint':_0x5663b0===null?_0x380360=_0x5d9c16(0x17a):_0x5663b0['constructor']&&(_0x380360=_0x5663b0[_0x5d9c16(0xfa)]['name']||_0x380360):_0x380360==='undefined'&&this[_0x5d9c16(0x18d)]&&_0x5663b0 instanceof this[_0x5d9c16(0x18d)]&&(_0x380360=_0x5d9c16(0x144)),_0x380360;}[_0x4b0180(0x100)](_0x118ec3){var _0x322371=_0x4b0180;return Object[_0x322371(0x192)][_0x322371(0x1ce)][_0x322371(0x131)](_0x118ec3);}[_0x4b0180(0x146)](_0x5c8658){var _0x2eb046=_0x4b0180;return _0x5c8658===_0x2eb046(0x1a3)||_0x5c8658==='string'||_0x5c8658===_0x2eb046(0x19b);}[_0x4b0180(0x177)](_0x36c873){var _0x3ee0b9=_0x4b0180;return _0x36c873==='Boolean'||_0x36c873===_0x3ee0b9(0x1c3)||_0x36c873===_0x3ee0b9(0x105);}[_0x4b0180(0x13e)](_0x4d59ed,_0x5ead68,_0x58f47f,_0x2b4a14,_0x4913e6,_0xe69cbc){var _0xcd7f03=this;return function(_0x16fb41){var _0x31eb1f=_0x270f,_0x686842=_0x4913e6[_0x31eb1f(0x1c7)][_0x31eb1f(0x1cc)],_0x56978b=_0x4913e6[_0x31eb1f(0x1c7)][_0x31eb1f(0xe6)],_0x65ce67=_0x4913e6[_0x31eb1f(0x1c7)][_0x31eb1f(0x1cd)];_0x4913e6[_0x31eb1f(0x1c7)][_0x31eb1f(0x1cd)]=_0x686842,_0x4913e6['node'][_0x31eb1f(0xe6)]=typeof _0x2b4a14==_0x31eb1f(0x19b)?_0x2b4a14:_0x16fb41,_0x4d59ed[_0x31eb1f(0x11d)](_0xcd7f03[_0x31eb1f(0xf1)](_0x5ead68,_0x58f47f,_0x2b4a14,_0x4913e6,_0xe69cbc)),_0x4913e6[_0x31eb1f(0x1c7)][_0x31eb1f(0x1cd)]=_0x65ce67,_0x4913e6[_0x31eb1f(0x1c7)]['index']=_0x56978b;};}[_0x4b0180(0x148)](_0x35ef7e,_0x1bcd98,_0x260b08,_0x45e2c8,_0x3410f7,_0x560b21,_0x31e786){var _0x49404a=_0x4b0180,_0x1f2291=this;return _0x1bcd98[_0x49404a(0x179)+_0x3410f7[_0x49404a(0x1ce)]()]=!0x0,function(_0x5cb159){var _0x5c15d1=_0x49404a,_0x26f7d2=_0x560b21[_0x5c15d1(0x1c7)][_0x5c15d1(0x1cc)],_0xb33255=_0x560b21['node'][_0x5c15d1(0xe6)],_0x1ea8d7=_0x560b21[_0x5c15d1(0x1c7)][_0x5c15d1(0x1cd)];_0x560b21[_0x5c15d1(0x1c7)][_0x5c15d1(0x1cd)]=_0x26f7d2,_0x560b21[_0x5c15d1(0x1c7)][_0x5c15d1(0xe6)]=_0x5cb159,_0x35ef7e['push'](_0x1f2291[_0x5c15d1(0xf1)](_0x260b08,_0x45e2c8,_0x3410f7,_0x560b21,_0x31e786)),_0x560b21[_0x5c15d1(0x1c7)]['parent']=_0x1ea8d7,_0x560b21[_0x5c15d1(0x1c7)]['index']=_0xb33255;};}[_0x4b0180(0xf1)](_0x29defb,_0x217cd2,_0x2272aa,_0x420e0f,_0x32f6b0){var _0x153d76=_0x4b0180,_0x2e8e78=this;_0x32f6b0||(_0x32f6b0=function(_0x44bcd6,_0x27c6bc){return _0x44bcd6[_0x27c6bc];});var _0x52b44f=_0x2272aa[_0x153d76(0x1ce)](),_0x42428b=_0x420e0f['expressionsToEvaluate']||{},_0x315551=_0x420e0f[_0x153d76(0x1c9)],_0x22af9f=_0x420e0f['isExpressionToEvaluate'];try{var _0x395530=this[_0x153d76(0xff)](_0x29defb),_0x2a8de8=_0x52b44f;_0x395530&&_0x2a8de8[0x0]==='\\x27'&&(_0x2a8de8=_0x2a8de8[_0x153d76(0xe0)](0x1,_0x2a8de8['length']-0x2));var _0x44221d=_0x420e0f[_0x153d76(0x133)]=_0x42428b['_p_'+_0x2a8de8];_0x44221d&&(_0x420e0f[_0x153d76(0x1c9)]=_0x420e0f[_0x153d76(0x1c9)]+0x1),_0x420e0f[_0x153d76(0x16e)]=!!_0x44221d;var _0x30c2e9=typeof _0x2272aa==_0x153d76(0x19d),_0x5efc2d={'name':_0x30c2e9||_0x395530?_0x52b44f:this['_propertyName'](_0x52b44f)};if(_0x30c2e9&&(_0x5efc2d[_0x153d76(0x19d)]=!0x0),!(_0x217cd2===_0x153d76(0x1c4)||_0x217cd2===_0x153d76(0xf6))){var _0x3247fa=this[_0x153d76(0x1bb)](_0x29defb,_0x2272aa);if(_0x3247fa&&(_0x3247fa[_0x153d76(0x188)]&&(_0x5efc2d['setter']=!0x0),_0x3247fa[_0x153d76(0x197)]&&!_0x44221d&&!_0x420e0f[_0x153d76(0x1bc)]))return _0x5efc2d[_0x153d76(0x13d)]=!0x0,this['_processTreeNodeResult'](_0x5efc2d,_0x420e0f),_0x5efc2d;}var _0x25e996;try{_0x25e996=_0x32f6b0(_0x29defb,_0x2272aa);}catch(_0x43e181){return _0x5efc2d={'name':_0x52b44f,'type':_0x153d76(0x1ba),'error':_0x43e181[_0x153d76(0x129)]},this['_processTreeNodeResult'](_0x5efc2d,_0x420e0f),_0x5efc2d;}var _0x59c957=this[_0x153d76(0x17f)](_0x25e996),_0x33d181=this[_0x153d76(0x146)](_0x59c957);if(_0x5efc2d[_0x153d76(0x106)]=_0x59c957,_0x33d181)this[_0x153d76(0x138)](_0x5efc2d,_0x420e0f,_0x25e996,function(){var _0x26f511=_0x153d76;_0x5efc2d[_0x26f511(0xf3)]=_0x25e996['valueOf'](),!_0x44221d&&_0x2e8e78['_capIfString'](_0x59c957,_0x5efc2d,_0x420e0f,{});});else{var _0x578404=_0x420e0f[_0x153d76(0x141)]&&_0x420e0f[_0x153d76(0xd9)]<_0x420e0f[_0x153d76(0x18e)]&&_0x420e0f[_0x153d76(0x1ca)][_0x153d76(0x145)](_0x25e996)<0x0&&_0x59c957!==_0x153d76(0x185)&&_0x420e0f['autoExpandPropertyCount']<_0x420e0f[_0x153d76(0xdf)];_0x578404||_0x420e0f['level']<_0x315551||_0x44221d?(this['serialize'](_0x5efc2d,_0x25e996,_0x420e0f,_0x44221d||{}),this[_0x153d76(0x10a)](_0x25e996,_0x5efc2d)):this['_processTreeNodeResult'](_0x5efc2d,_0x420e0f,_0x25e996,function(){var _0x5417f6=_0x153d76;_0x59c957===_0x5417f6(0x17a)||_0x59c957==='undefined'||(delete _0x5efc2d['value'],_0x5efc2d[_0x5417f6(0x169)]=!0x0);});}return _0x5efc2d;}finally{_0x420e0f[_0x153d76(0x133)]=_0x42428b,_0x420e0f[_0x153d76(0x1c9)]=_0x315551,_0x420e0f['isExpressionToEvaluate']=_0x22af9f;}}['_capIfString'](_0x334c26,_0x28fa86,_0x577bcd,_0x5b7505){var _0x448b11=_0x4b0180,_0x350775=_0x5b7505['strLength']||_0x577bcd[_0x448b11(0x12e)];if((_0x334c26===_0x448b11(0x11f)||_0x334c26===_0x448b11(0x1c3))&&_0x28fa86[_0x448b11(0xf3)]){let _0x95fb65=_0x28fa86[_0x448b11(0xf3)][_0x448b11(0xfe)];_0x577bcd[_0x448b11(0x1cb)]+=_0x95fb65,_0x577bcd[_0x448b11(0x1cb)]>_0x577bcd[_0x448b11(0xea)]?(_0x28fa86[_0x448b11(0x169)]='',delete _0x28fa86[_0x448b11(0xf3)]):_0x95fb65>_0x350775&&(_0x28fa86[_0x448b11(0x169)]=_0x28fa86[_0x448b11(0xf3)][_0x448b11(0xe0)](0x0,_0x350775),delete _0x28fa86['value']);}}[_0x4b0180(0xff)](_0x5f7da5){var _0x306748=_0x4b0180;return!!(_0x5f7da5&&_0x2c44e3[_0x306748(0xdd)]&&this[_0x306748(0x100)](_0x5f7da5)===_0x306748(0x172)&&_0x5f7da5[_0x306748(0x126)]);}[_0x4b0180(0x14b)](_0x3305a1){var _0x23f858=_0x4b0180;if(_0x3305a1[_0x23f858(0xf8)](/^\\d+$/))return _0x3305a1;var _0x527cad;try{_0x527cad=JSON['stringify'](''+_0x3305a1);}catch{_0x527cad='\\x22'+this[_0x23f858(0x100)](_0x3305a1)+'\\x22';}return _0x527cad[_0x23f858(0xf8)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x527cad=_0x527cad[_0x23f858(0xe0)](0x1,_0x527cad[_0x23f858(0xfe)]-0x2):_0x527cad=_0x527cad[_0x23f858(0xf4)](/'/g,'\\x5c\\x27')[_0x23f858(0xf4)](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x527cad;}[_0x4b0180(0x138)](_0x78a47e,_0x40d9d5,_0x365065,_0x2688d0){var _0x5e64ed=_0x4b0180;this[_0x5e64ed(0xf0)](_0x78a47e,_0x40d9d5),_0x2688d0&&_0x2688d0(),this[_0x5e64ed(0x10a)](_0x365065,_0x78a47e),this['_treeNodePropertiesAfterFullValue'](_0x78a47e,_0x40d9d5);}[_0x4b0180(0xf0)](_0x311d54,_0x3facb6){var _0x28cc72=_0x4b0180;this[_0x28cc72(0x1d5)](_0x311d54,_0x3facb6),this[_0x28cc72(0x107)](_0x311d54,_0x3facb6),this[_0x28cc72(0x117)](_0x311d54,_0x3facb6),this[_0x28cc72(0x143)](_0x311d54,_0x3facb6);}[_0x4b0180(0x1d5)](_0x563402,_0x1b01bf){}[_0x4b0180(0x107)](_0x2fd52a,_0x49fa8c){}[_0x4b0180(0x1b6)](_0xcf34b4,_0x5b1d4b){}['_isUndefined'](_0x4ac0c0){var _0x4b736a=_0x4b0180;return _0x4ac0c0===this[_0x4b736a(0x1be)];}[_0x4b0180(0x1a4)](_0x377307,_0x5e8738){var _0x5b1e07=_0x4b0180;this[_0x5b1e07(0x1b6)](_0x377307,_0x5e8738),this[_0x5b1e07(0x191)](_0x377307),_0x5e8738['sortProps']&&this['_sortProps'](_0x377307),this[_0x5b1e07(0x173)](_0x377307,_0x5e8738),this[_0x5b1e07(0x12f)](_0x377307,_0x5e8738),this[_0x5b1e07(0x1b2)](_0x377307);}['_additionalMetadata'](_0x3effa7,_0xb6fa7d){var _0x682a8b=_0x4b0180;let _0x1454d2;try{_0x2c44e3[_0x682a8b(0x18c)]&&(_0x1454d2=_0x2c44e3[_0x682a8b(0x18c)]['error'],_0x2c44e3[_0x682a8b(0x18c)][_0x682a8b(0x1a1)]=function(){}),_0x3effa7&&typeof _0x3effa7[_0x682a8b(0xfe)]==_0x682a8b(0x19b)&&(_0xb6fa7d[_0x682a8b(0xfe)]=_0x3effa7['length']);}catch{}finally{_0x1454d2&&(_0x2c44e3[_0x682a8b(0x18c)][_0x682a8b(0x1a1)]=_0x1454d2);}if(_0xb6fa7d[_0x682a8b(0x106)]==='number'||_0xb6fa7d['type']===_0x682a8b(0x105)){if(isNaN(_0xb6fa7d[_0x682a8b(0xf3)]))_0xb6fa7d[_0x682a8b(0x140)]=!0x0,delete _0xb6fa7d[_0x682a8b(0xf3)];else switch(_0xb6fa7d[_0x682a8b(0xf3)]){case Number['POSITIVE_INFINITY']:_0xb6fa7d['positiveInfinity']=!0x0,delete _0xb6fa7d[_0x682a8b(0xf3)];break;case Number[_0x682a8b(0x12c)]:_0xb6fa7d['negativeInfinity']=!0x0,delete _0xb6fa7d[_0x682a8b(0xf3)];break;case 0x0:this['_isNegativeZero'](_0xb6fa7d[_0x682a8b(0xf3)])&&(_0xb6fa7d[_0x682a8b(0x118)]=!0x0);break;}}else _0xb6fa7d[_0x682a8b(0x106)]===_0x682a8b(0x185)&&typeof _0x3effa7[_0x682a8b(0x113)]==_0x682a8b(0x11f)&&_0x3effa7[_0x682a8b(0x113)]&&_0xb6fa7d[_0x682a8b(0x113)]&&_0x3effa7[_0x682a8b(0x113)]!==_0xb6fa7d[_0x682a8b(0x113)]&&(_0xb6fa7d[_0x682a8b(0xe9)]=_0x3effa7[_0x682a8b(0x113)]);}['_isNegativeZero'](_0x37202d){var _0x2d7e58=_0x4b0180;return 0x1/_0x37202d===Number[_0x2d7e58(0x12c)];}[_0x4b0180(0xeb)](_0x4d4357){var _0x3456c1=_0x4b0180;!_0x4d4357['props']||!_0x4d4357[_0x3456c1(0xf2)][_0x3456c1(0xfe)]||_0x4d4357[_0x3456c1(0x106)]===_0x3456c1(0x1c4)||_0x4d4357[_0x3456c1(0x106)]===_0x3456c1(0xdd)||_0x4d4357[_0x3456c1(0x106)]===_0x3456c1(0x153)||_0x4d4357[_0x3456c1(0xf2)][_0x3456c1(0x147)](function(_0x3007be,_0x4b0ccc){var _0x1e9466=_0x3456c1,_0x2d8431=_0x3007be['name']['toLowerCase'](),_0x40ac76=_0x4b0ccc['name'][_0x1e9466(0x10c)]();return _0x2d8431<_0x40ac76?-0x1:_0x2d8431>_0x40ac76?0x1:0x0;});}[_0x4b0180(0x173)](_0x58a11e,_0x5f251b){var _0x2ab997=_0x4b0180;if(!(_0x5f251b[_0x2ab997(0x189)]||!_0x58a11e[_0x2ab997(0xf2)]||!_0x58a11e[_0x2ab997(0xf2)]['length'])){for(var _0x4add58=[],_0x4f526=[],_0x264f8c=0x0,_0xbc8be4=_0x58a11e[_0x2ab997(0xf2)][_0x2ab997(0xfe)];_0x264f8c<_0xbc8be4;_0x264f8c++){var _0x55c185=_0x58a11e['props'][_0x264f8c];_0x55c185[_0x2ab997(0x106)]===_0x2ab997(0x185)?_0x4add58[_0x2ab997(0x11d)](_0x55c185):_0x4f526[_0x2ab997(0x11d)](_0x55c185);}if(!(!_0x4f526[_0x2ab997(0xfe)]||_0x4add58[_0x2ab997(0xfe)]<=0x1)){_0x58a11e[_0x2ab997(0xf2)]=_0x4f526;var _0x588b3b={'functionsNode':!0x0,'props':_0x4add58};this[_0x2ab997(0x1d5)](_0x588b3b,_0x5f251b),this[_0x2ab997(0x1b6)](_0x588b3b,_0x5f251b),this[_0x2ab997(0x191)](_0x588b3b),this[_0x2ab997(0x143)](_0x588b3b,_0x5f251b),_0x588b3b['id']+='\\x20f',_0x58a11e['props'][_0x2ab997(0x176)](_0x588b3b);}}}['_addLoadNode'](_0x1b1f14,_0x40a58a){}[_0x4b0180(0x191)](_0x22e218){}[_0x4b0180(0x132)](_0x54145e){var _0x5da4bd=_0x4b0180;return Array[_0x5da4bd(0x135)](_0x54145e)||typeof _0x54145e==_0x5da4bd(0x15c)&&this[_0x5da4bd(0x100)](_0x54145e)==='[object\\x20Array]';}[_0x4b0180(0x143)](_0x54e4ae,_0x3c6161){}[_0x4b0180(0x1b2)](_0x3ad36f){var _0x5ad998=_0x4b0180;delete _0x3ad36f[_0x5ad998(0xe1)],delete _0x3ad36f[_0x5ad998(0x1a6)],delete _0x3ad36f['_hasMapOnItsPath'];}[_0x4b0180(0x117)](_0x142f29,_0x1def73){}}let _0x118761=new _0x72172c(),_0x3396d9={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x270144={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2};function _0x7ab528(_0x4a5eac,_0x136c98,_0x3e6605,_0x5466e3,_0x4f33e8,_0x46425e){var _0x588839=_0x4b0180;let _0x416f30,_0x4fe062;try{_0x4fe062=_0x4defb4(),_0x416f30=_0x51817a[_0x136c98],!_0x416f30||_0x4fe062-_0x416f30['ts']>0x1f4&&_0x416f30[_0x588839(0x150)]&&_0x416f30[_0x588839(0x1c1)]/_0x416f30[_0x588839(0x150)]<0x64?(_0x51817a[_0x136c98]=_0x416f30={'count':0x0,'time':0x0,'ts':_0x4fe062},_0x51817a[_0x588839(0x1ae)]={}):_0x4fe062-_0x51817a[_0x588839(0x1ae)]['ts']>0x32&&_0x51817a[_0x588839(0x1ae)][_0x588839(0x150)]&&_0x51817a[_0x588839(0x1ae)][_0x588839(0x1c1)]/_0x51817a[_0x588839(0x1ae)][_0x588839(0x150)]<0x64&&(_0x51817a[_0x588839(0x1ae)]={});let _0xff5ec9=[],_0x4d3211=_0x416f30[_0x588839(0x167)]||_0x51817a['hits'][_0x588839(0x167)]?_0x270144:_0x3396d9,_0x122c7b=_0x26dddf=>{var _0x117334=_0x588839;let _0x1b31be={};return _0x1b31be['props']=_0x26dddf['props'],_0x1b31be[_0x117334(0x1c5)]=_0x26dddf[_0x117334(0x1c5)],_0x1b31be[_0x117334(0x12e)]=_0x26dddf[_0x117334(0x12e)],_0x1b31be[_0x117334(0xea)]=_0x26dddf['totalStrLength'],_0x1b31be['autoExpandLimit']=_0x26dddf[_0x117334(0xdf)],_0x1b31be['autoExpandMaxDepth']=_0x26dddf[_0x117334(0x18e)],_0x1b31be[_0x117334(0x17c)]=!0x1,_0x1b31be['noFunctions']=!_0x39d98c,_0x1b31be[_0x117334(0x1c9)]=0x1,_0x1b31be['level']=0x0,_0x1b31be[_0x117334(0x170)]=_0x117334(0x1d3),_0x1b31be[_0x117334(0x14d)]=_0x117334(0x1bf),_0x1b31be['autoExpand']=!0x0,_0x1b31be['autoExpandPreviousObjects']=[],_0x1b31be['autoExpandPropertyCount']=0x0,_0x1b31be[_0x117334(0x1bc)]=!0x0,_0x1b31be[_0x117334(0x1cb)]=0x0,_0x1b31be['node']={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x1b31be;};for(var _0x49ec31=0x0;_0x49ec31<_0x4f33e8[_0x588839(0xfe)];_0x49ec31++)_0xff5ec9['push'](_0x118761[_0x588839(0x10e)]({'timeNode':_0x4a5eac===_0x588839(0x1c1)||void 0x0},_0x4f33e8[_0x49ec31],_0x122c7b(_0x4d3211),{}));if(_0x4a5eac==='trace'||_0x4a5eac==='error'){let _0x167f69=Error['stackTraceLimit'];try{Error['stackTraceLimit']=0x1/0x0,_0xff5ec9[_0x588839(0x11d)](_0x118761[_0x588839(0x10e)]({'stackNode':!0x0},new Error()[_0x588839(0x103)],_0x122c7b(_0x4d3211),{'strLength':0x1/0x0}));}finally{Error[_0x588839(0x1b5)]=_0x167f69;}}return{'method':_0x588839(0x10d),'version':_0xf7bfb5,'args':[{'ts':_0x3e6605,'session':_0x5466e3,'args':_0xff5ec9,'id':_0x136c98,'context':_0x46425e}]};}catch(_0x2a604a){return{'method':_0x588839(0x10d),'version':_0xf7bfb5,'args':[{'ts':_0x3e6605,'session':_0x5466e3,'args':[{'type':_0x588839(0x1ba),'error':_0x2a604a&&_0x2a604a[_0x588839(0x129)]}],'id':_0x136c98,'context':_0x46425e}]};}finally{try{if(_0x416f30&&_0x4fe062){let _0xd3a7cf=_0x4defb4();_0x416f30['count']++,_0x416f30['time']+=_0x242d41(_0x4fe062,_0xd3a7cf),_0x416f30['ts']=_0xd3a7cf,_0x51817a[_0x588839(0x1ae)][_0x588839(0x150)]++,_0x51817a['hits'][_0x588839(0x1c1)]+=_0x242d41(_0x4fe062,_0xd3a7cf),_0x51817a[_0x588839(0x1ae)]['ts']=_0xd3a7cf,(_0x416f30['count']>0x32||_0x416f30[_0x588839(0x1c1)]>0x64)&&(_0x416f30[_0x588839(0x167)]=!0x0),(_0x51817a[_0x588839(0x1ae)][_0x588839(0x150)]>0x3e8||_0x51817a['hits'][_0x588839(0x1c1)]>0x12c)&&(_0x51817a[_0x588839(0x1ae)][_0x588839(0x167)]=!0x0);}}catch{}}}return _0x7ab528;}((_0x67ca0e,_0x7da5c7,_0x1f23a3,_0x150fe3,_0x16d60b,_0x3d22b4,_0x280d74,_0x14e81f,_0x1565e2,_0x1ec69d,_0xd0261)=>{var _0x4c8016=_0x166ebe;if(_0x67ca0e['_console_ninja'])return _0x67ca0e['_console_ninja'];if(!H(_0x67ca0e,_0x14e81f,_0x16d60b))return _0x67ca0e['_console_ninja']={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x67ca0e[_0x4c8016(0x104)];let _0x34687f=B(_0x67ca0e),_0x4df412=_0x34687f[_0x4c8016(0x1d2)],_0xaf77a7=_0x34687f['timeStamp'],_0x15831a=_0x34687f[_0x4c8016(0x181)],_0x476803={'hits':{},'ts':{}},_0x5295aa=X(_0x67ca0e,_0x1565e2,_0x476803,_0x3d22b4),_0xc1667b=_0x38b968=>{_0x476803['ts'][_0x38b968]=_0xaf77a7();},_0x1f8580=(_0x1055eb,_0x3d9c13)=>{var _0x145f5a=_0x4c8016;let _0x44838f=_0x476803['ts'][_0x3d9c13];if(delete _0x476803['ts'][_0x3d9c13],_0x44838f){let _0x51c443=_0x4df412(_0x44838f,_0xaf77a7());_0x16c7f8(_0x5295aa(_0x145f5a(0x1c1),_0x1055eb,_0x15831a(),_0x1c1b37,[_0x51c443],_0x3d9c13));}},_0x5597e7=_0x59a502=>{var _0x28f657=_0x4c8016,_0x590b16;return _0x16d60b===_0x28f657(0x166)&&_0x67ca0e[_0x28f657(0xdc)]&&((_0x590b16=_0x59a502==null?void 0x0:_0x59a502[_0x28f657(0x13c)])==null?void 0x0:_0x590b16['length'])&&(_0x59a502[_0x28f657(0x13c)][0x0][_0x28f657(0xdc)]=_0x67ca0e['origin']),_0x59a502;};_0x67ca0e[_0x4c8016(0x104)]={'consoleLog':(_0x5a4639,_0x1b7300)=>{var _0x5296a8=_0x4c8016;_0x67ca0e[_0x5296a8(0x18c)]['log'][_0x5296a8(0x113)]!==_0x5296a8(0x13a)&&_0x16c7f8(_0x5295aa('log',_0x5a4639,_0x15831a(),_0x1c1b37,_0x1b7300));},'consoleTrace':(_0x1a589f,_0x517052)=>{var _0x470ae8=_0x4c8016,_0x285535,_0x27a002;_0x67ca0e[_0x470ae8(0x18c)][_0x470ae8(0x10d)][_0x470ae8(0x113)]!=='disabledTrace'&&((_0x27a002=(_0x285535=_0x67ca0e[_0x470ae8(0xfd)])==null?void 0x0:_0x285535[_0x470ae8(0x1cf)])!=null&&_0x27a002['node']&&(_0x67ca0e[_0x470ae8(0x152)]=!0x0),_0x16c7f8(_0x5597e7(_0x5295aa(_0x470ae8(0x158),_0x1a589f,_0x15831a(),_0x1c1b37,_0x517052))));},'consoleError':(_0x53d932,_0x54ca98)=>{var _0x198203=_0x4c8016;_0x67ca0e[_0x198203(0x152)]=!0x0,_0x16c7f8(_0x5597e7(_0x5295aa(_0x198203(0x1a1),_0x53d932,_0x15831a(),_0x1c1b37,_0x54ca98)));},'consoleTime':_0x5cc8eb=>{_0xc1667b(_0x5cc8eb);},'consoleTimeEnd':(_0xd90286,_0x5433e9)=>{_0x1f8580(_0x5433e9,_0xd90286);},'autoLog':(_0x4fabdf,_0x2ea360)=>{var _0x5550e9=_0x4c8016;_0x16c7f8(_0x5295aa(_0x5550e9(0x10d),_0x2ea360,_0x15831a(),_0x1c1b37,[_0x4fabdf]));},'autoLogMany':(_0x119ac7,_0x2e9572)=>{var _0x524d72=_0x4c8016;_0x16c7f8(_0x5295aa(_0x524d72(0x10d),_0x119ac7,_0x15831a(),_0x1c1b37,_0x2e9572));},'autoTrace':(_0x57eb0a,_0x230f3f)=>{_0x16c7f8(_0x5597e7(_0x5295aa('trace',_0x230f3f,_0x15831a(),_0x1c1b37,[_0x57eb0a])));},'autoTraceMany':(_0x4c8bfe,_0x368196)=>{var _0x453309=_0x4c8016;_0x16c7f8(_0x5597e7(_0x5295aa(_0x453309(0x158),_0x4c8bfe,_0x15831a(),_0x1c1b37,_0x368196)));},'autoTime':(_0x2d17a7,_0x3a01d0,_0x36305b)=>{_0xc1667b(_0x36305b);},'autoTimeEnd':(_0x281d30,_0xf53ac,_0x54085a)=>{_0x1f8580(_0xf53ac,_0x54085a);},'coverage':_0x2b620a=>{var _0x53ba4d=_0x4c8016;_0x16c7f8({'method':_0x53ba4d(0x15b),'version':_0x3d22b4,'args':[{'id':_0x2b620a}]});}};let _0x16c7f8=q(_0x67ca0e,_0x7da5c7,_0x1f23a3,_0x150fe3,_0x16d60b,_0x1ec69d,_0xd0261),_0x1c1b37=_0x67ca0e[_0x4c8016(0x15d)];return _0x67ca0e[_0x4c8016(0x104)];})(globalThis,'127.0.0.1',_0x166ebe(0x1a5),\"c:\\\\Users\\\\mirko.zoranovic\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-1.0.388\\\\node_modules\",_0x166ebe(0xed),_0x166ebe(0x110),_0x166ebe(0x1ab),_0x166ebe(0xde),_0x166ebe(0x123),_0x166ebe(0xe7),_0x166ebe(0x156));");}catch(e){}};/* istanbul ignore next */function oo_oo(i,...v){try{oo_cm().consoleLog(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tr(i,...v){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tx(i,...v){try{oo_cm().consoleError(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_ts(v){try{oo_cm().consoleTime(v);}catch(e){} return v;};/* istanbul ignore next */function oo_te(v, i){try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v;};/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/
